
import "core-js/stable"; import "regenerator-runtime/runtime"
import { createApp } from "vue"
import App from "./App.vue"
import { store } from "./store"
import router from "./router"
import { GraphQLClient } from "graphql-request"
import UUID from "vue3-uuid";
import gcPublisher from "./plugins/publisher.js";
//@ts-ignore
import gcFeatures from "./plugins/features.js";
//@ts-ignore
import gcPermissions from "./plugins/permissions";
//@ts-ignore
import nullifyFalsyValues from "./plugins/utils.js";
//@ts-ignore
import CognitoPlugin from "./cognito-plugin.js";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css"
import { loadFonts } from "./plugins/webfontloader"
import "@mdi/font/css/materialdesignicons.css" // Ensure you are using css-loader
import { aliases, mdi } from "vuetify/iconsets/mdi"
// import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import Unauthorised from "@/components/Library/Unauthorised.vue"
import VFlex from "@/components/Migrated/VFlex.vue"
import "vuetify/styles"
import { createVuetify } from "vuetify"
import * as labsComponents from "vuetify/labs/components"
import * as components from "vuetify/components"
import { VueDraggableNext } from "vue-draggable-next"
// @ts-ignore
import "./styles/global.scss"
loadFonts()
const graphcmsclient = new GraphQLClient(
    "https://api-eu-west-2.graphcms.com/v2/cl39y5wee00uk01z2fps4a2w4/master"
);

const lightTheme = {
    dark: false,
    colors: {
        background: "#FFFFFF",
        surface: "#FFFFFF",
        primary: "#67247C",
        "primary-darken-1": "#ccc",
        secondary: "#03DAC6",
        "secondary-darken-1": "#979797",
        error: "#B00020",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00",

    },
    defaultAssets: {
        font: {
            family: "Rubik, sans-serif"
        }
    }
}
export const vuetify = createVuetify({
    icons: {
        defaultSet: "mdi",
        aliases,
        sets: {
            mdi,

        },
    },

    theme: {
        defaultTheme: "lightTheme",
        themes: {
            lightTheme,
        },

    },
    components: {
        ...components,
        ...labsComponents,
    },
})

export const app = createApp(App)
// app.config.productionTip = false

router.beforeEach(async (to, from, next) => {
    console.log("before enter route getAuthenticatedUser", app.config.globalProperties.$getAuthenticatedUser())
    const isAuthenticated = app.config.globalProperties.$getAuthenticatedUser() !== null

    const loginPages = ["Login", "LoginSetPassword", "LoginResetPassword", "Password Reset"]
    if (to.path.includes("/pagebuilder")) {
        if (process.env.NODE_ENV === "development") {
            window.location.assign("http://localhost:3000")
        } else {
            window.location.assign(`https://${window.location.hostname}/pagebuilder/`)
        }
    }
    // @ts-ignore
    if (!loginPages.includes(to.name) && !isAuthenticated) {
        next({ name: "Login" })
        return
    }
    else {
        next()
        return
    }

})

app.mixin({
    beforeCreate() {
        // @ts-ignore
        this.$graphcms = graphcmsclient
    }
})
//@ts-ignore
app.use(UUID);
app.use(CognitoPlugin);
app.use(gcPublisher);
app.use(gcFeatures);
app.use(gcPermissions);
app.use(nullifyFalsyValues);
app.use(vuetify)
app.use(store)
app.use(router)
app.component("draggable", VueDraggableNext)
app.component("datetime", VueDatePicker);
app.component("Unauthorised", Unauthorised);
app.component("v-flex", VFlex)
app.mount("#app")
// @ts-ignore
window.vueinstance = app
import { uuid } from "vue3-uuid";
app.config.globalProperties.$uuid = uuid
